import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { NextStepTypes } from "../../../modules/constants";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import {
  mapDispatchToProps,
  mapStateToProps,
  nextStepsReducer,
} from "./NextSteps.store";
import Introduction from "../../smart/LCF402/Introduction/Introduction";
import SingleNextStep from "../BeyondXLH/SingleNextStep/SingleNextStep";
import AdultConsent from "../Consent/Consent";
import history from "../../../modules/history";
import { ProfileCard } from "../../ui-library/ProfileCard/ProfileCard";

export const SmartNextSteps = (props) => {
  const { stepData, fetchNextSteps, resetState } = props;

  const showProfileCard = useMemo(() => {
    return ![NextStepTypes.ADVERSE_EVENT].includes(stepData?.type);
  }, [stepData]);

  useEffect(() => {
    if (stepData === null) {
      fetchNextSteps();
    } else if (!Object.values(NextStepTypes).includes(stepData?.type)) {
      history.push("/participant");
    }
  }, [stepData, fetchNextSteps]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const viewForType = (type) => {
    switch (type) {
      case NextStepTypes.BIRTHDATE:
        return <Introduction />;
      case NextStepTypes.CONSENT:
        return <AdultConsent {...{ stepData }} />;
      case NextStepTypes.ADVERSE_EVENT:
        return <SingleNextStep surveyId={stepData?.surveyId} />;
      case NextStepTypes.CHILD_ASSENT:
        return <>TODO: Child Assent Flow View</>;
      case NextStepTypes.ADOLSCENT_ASSENT:
        return <>TODO: Adolescent Assent Flow View</>;
      default:
        return <LoadingSpinner />;
    }
  };
  return showProfileCard ? (
    <ProfileCard showIcon={false} hasSeparator={false}>
      {viewForType(stepData?.type)}
    </ProfileCard>
  ) : (
    viewForType(stepData?.type)
  );
};

export default dynamic(
  "nextStepsReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(nextStepsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartNextSteps));
